
import './App.css';
import AppRoutes from './Routes/AppRoutes';
import React from 'react';
import { Toastify } from './Components/Common/Toastify';
function App() {

  return (
    <>

      <Toastify />
      <AppRoutes />

    </>
  );
}

export default App;
